<app-walkthrough-slide>
  <div copy class="wt-eyebrow">{{ 'app.pages.auth.walkthrough.pane4.eyebrow' | translate }}</div>
  <h2 copy class="wt-h2">{{ 'app.pages.auth.walkthrough.pane4.title' | translate }}</h2>

  <!-- Same mechanism as pane 3, different split point — which is the point.
       EN opens `The ` (trailing space), FR opens `L'` (none). -->
  <p copy class="wt-p">
    @for (segment of 'app.pages.auth.walkthrough.pane4.body' | translateParts; track $index) {
      @if (segment.kind === 'text') {
        <span>{{ segment.text }}</span>
      } @else if (segment.name === 'key') {
        <span class="wt-key">{{ 'app.pages.auth.walkthrough.pane4.key' | translate }}</span>
      }
    }
  </p>

  <div copy class="wt-bul">
    <!-- The lead bullet, highlighted. First in the DOM in the source too. -->
    <div class="wt-bul__i wt-bul__i--hi">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane4.bullet.multiModule' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane4.bullet.approvals' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane4.bullet.history' | translate }}</span>
    </div>
  </div>

  <!-- Four steps, three connectors. Inert: `<div>`s, no handler, no canvas.
       One wrapper, because the chain is generated (see `.vstack`). -->
  <div viz class="vstack">
    @for (node of nodes; track node.labelKey; let first = $first) {
      @if (!first) {
        <div class="vconn" aria-hidden="true"></div>
      }
      <div class="vnode">
        <span class="vnode__b" [ngClass]="'vnode__b--' + node.tone">
          <ion-icon [name]="node.icon" aria-hidden="true"></ion-icon>
        </span>
        <span>{{ node.labelKey | translate }}</span>
      </div>
    }
  </div>
</app-walkthrough-slide>
